import {
  ExpandLess,
  ExpandMore,
  KeyboardDoubleArrowDown,
  KeyboardDoubleArrowUp,
  UnfoldMore,
} from '@mui/icons-material'
import { Box, MenuItem, Typography } from '@mui/material'
import { type SimpleSelectOption } from '@workwave-tidal/core/components'

import * as OrderTexts from '../../../../../../intl'
import { form } from '../../../formState'

const getPriorityValues = (): SimpleSelectOption<string>[] => [
  {
    label: OrderTexts.getPriorityHighestText(),
    value: '20',
    icon: <KeyboardDoubleArrowUp color="error" />,
  },
  {
    label: OrderTexts.getPriorityHigherText(),
    value: '10',
    icon: <ExpandLess color="warning" />,
  },
  {
    label: OrderTexts.getPriorityNormalText(),
    value: '0',
    icon: <UnfoldMore color="action" />,
  },
  {
    label: OrderTexts.getPriorityLowerText(),
    value: '-10',
    icon: <ExpandMore color="info" />,
  },
  {
    label: OrderTexts.getPriorityLowestText(),
    value: '-20',
    icon: <KeyboardDoubleArrowDown color="success" />,
  },
]

export function Priority() {
  const priorityValues: SimpleSelectOption<string>[] = getPriorityValues()

  // Custom render for options in the dropdown
  const renderPriorityOption = (option: SimpleSelectOption<string>) => (
    <MenuItem key={option.value} value={option.value}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {option.icon}
        <Typography variant="body1">{option.label}</Typography>
      </Box>
    </MenuItem>
  )

  // Custom render for selected value
  const renderPriorityValue = (option: SimpleSelectOption<string>) => {
    if (!option) return null
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {option.icon}
        <Typography variant="body1">{option.label}</Typography>
      </Box>
    )
  }

  return (
    <form.SimpleSelect
      label={OrderTexts.geFieldLabelPriorityText()}
      name="order.priority"
      testId="priority"
      options={priorityValues}
      renderOptions={options => options.map(option => renderPriorityOption(option))}
      renderValue={renderPriorityValue}
      parse={(value: string) => parseInt(value).toString()}
      format={(value: number | string) => value.toString()}
    />
  )
}
